import { render, staticRenderFns } from "./SchoolEventRegisteredModal.vue?vue&type=template&id=410db297&scoped=true&"
import script from "./SchoolEventRegisteredModal.vue?vue&type=script&lang=ts&"
export * from "./SchoolEventRegisteredModal.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolEventRegisteredModal.vue?vue&type=style&index=0&id=410db297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410db297",
  null
  
)

export default component.exports